import { render, staticRenderFns } from "./UserCourseTime.vue?vue&type=template&id=5407319a&scoped=true&"
import script from "./UserCourseTime.vue?vue&type=script&lang=js&"
export * from "./UserCourseTime.vue?vue&type=script&lang=js&"
import style0 from "./UserCourseTime.vue?vue&type=style&index=0&id=5407319a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5407319a",
  null
  
)

export default component.exports